module.exports = __webpack_public_path__ + "2ccfd0fcf58fdd48aee68d5c74cc4ddd.png";